export default {
    DataInsertSuccess: "登録しました。",
    DataUpdateSuccess: "更新しました。",
    DataDeleteSuccess: "削除しました。",
    DataSettingSuccess:"設定しました。",
    
    LogOutConfirm: "ログアウトしますか?",
    LogOut: "ログアウトされました。",

    // エラー
    ModalTypeError:	    "送信情報に不具合があり、実行に失敗しました。",
    AuthCheckError:	    "権限が無いため、実行に失敗しました。",
    DataSelectError:    "取得に失敗しました。",
    DataInsertError:    "登録に失敗しました。",
    DataUpdateError:    "更新に失敗しました。",
    DataDeleteError:    "削除に失敗しました。",
    DataSettingError:   "設定に失敗しました。",
    DataSettingPartialError: "{0}の設定に失敗しました。ほかの項目は設定されています。",
    CompanySelectError:	"会社情報が無いため、情報取得に失敗しました。",
    FindDataError:	    "必要な情報が不足しているため、実行に失敗しました。",
    GetDataError:       "データの取得に失敗しました。管理者に問い合わせください。",
    ExecutionFailedError_Placeholder:        "{0}の実行に失敗しました。管理者にお問い合わせください。",
    ProcessingFailedError: "処理に失敗しました。管理者にお問い合わせください。",
    NoDataDeleteError:    "削除する項目がありません。",
    GetDataError_Server: "サーバーからデータ取得に失敗しました。",
    DeletedModalError:	  "選択した項目はすでに削除されています。",
    PrefixDuplicateError: "プレフィックス {0} はすでに登録されているため、登録に失敗しました。",
    multipleChoiceUpdateError: "複数選択の時は更新できません。",
    NoChoiceDeleteError: "削除する項目を選択してください。",
    NoChoiceUpdateError: "更新する項目を選択してください。",
    RegisteredUserPermissionError: "ユーザーが登録されている権限は削除できません。",
    UpdateModalSelectError: "編集する時には一つだけ選択してください。",
    ModalSelectError: "実行する項目を選択してください。",
    GetS3PreSignedUrl: "音声の取得に失敗しました。管理者に問い合わせください。",
    NotFoundIdentifier: "会社識別子が設定されていません。管理者に問い合わせください。",
    NoUserIdCandidate: "ユーザーID候補が見つかりませんでした。管理者に問い合わせください。",
    DownloadError: "ファイルのダウンロードに失敗しました。",
    NoDataToDownload: "ダウンロード可能なデータが存在しません。",
    LogFileNotFound: "ログファイルは既に削除されています。",

    // 画面個別設定
    // ユーザー
    User_DataInsertSuccess: "を登録しました。",
    User_InsertRegisteredUserError: "既存ユーザーか過去に登録があるため、登録できませんでした。",
    User_InvalidParameterError: "メールアドレス または パスワード のフォーマットが正しくないため、登録できませんでした。",
    User_UpdateModalSelectError: "編集する時には一つだけ選択してください。",
    User_ModalSelectError: "一つの項目以上選択してください。",
    User_IsLoginedUserError: "は現在ログイン中のユーザーのため、削除できません。",
    User_DeviceOwnError: "選択したデバイスは他のユーザーが所有しているため、登録できません。",
    // デバイス
    Device_IsOwnedDeviceError: "割り当てユーザーがいるため、削除できません。",

    SignIn_VerifyLink: "ユーザー認証はこちら",
    SignIn_ResetPasswordLink: "パスワードをお忘れの方はこちら",
    SignIn_SignInFailed: "ユーザーIDまたはパスワードが違います。",
    NotAuthorizedException: "パスワードが違います。",
    SignIn_NotMatchCodeOrExpiredError: "入力されたコードは間違っているか有効期限が切れています。",
    SignIn_NotMatchCodeError: "入力されたコードが間違っています。",
    SignIn_ExecutionFailedError: "実行に失敗しました。",
    SignIn_PasswordResetError: "パスワードリセットに失敗しました。\nメールアドレスや認証コードを再確認してください。",
    SignIn_UserNotFoundError: "入力されたメールアドレスは登録されていません。",
    SignIn_TooMuchFailsError: "認証エラーの回数が上限を超えました。再度コードを発行してください。",
    SignIn_NotConfirmedUserError: "未認証のユーザーです。ユーザー認証を行ってください。",
    SignIn_VerifySuccess: "認証に成功しました。",
    SignIn_SentVerificationCode: "認証コードを送信しました。",
    SignIn_ResetPasswordSuccess: "パスワードの再設定に成功しました。",
    SignIn_ConfirmResend: "再送信しますか？",
    NoDepartmentError: "所属している拠点またはフロアがありません。\n管理者に所属変更依頼を出してください。",
    SignIn_NoExistMailAlert1: "パスワード再設定用の認証コードをメールアドレスに送信します。",
    SignIn_NoExistMailAlert2: "使用しているメールアドレスがメールを受信出来ることを確認して下さい。",
    SignIn_ResetPasswordExpireMessage: "認証コードは１時間以内に入力してください。",

    // 権限管理
    Permission_BasePermissionDeleteError: "基本権限のため削除できません。",
    Permission_UserCountDeleteError: "利用ユーザーがいる場合は削除できません。",

    UserNotFoundException:"ユーザーが存在しません。システム管理者までお問合せください。",
    TooManyRequestsException:"リクエストが多かったため、削除ができませんでした。後でお試しください。",
    UserNotConfirmedException:"確認されなかったアカウントです。",

    //音声一覧
    Record_CustomerDelete:"電話帳から削除します。",
    Record_VoiceDeleted: "削除",
    Record_VoiceDelete: "録音音声を削除します。",
    Record_VoiceRetry: "テキスト化を再実行しますか？",
    Record_VoiceRetryRequested: "再実行リクエストを受け付けました。完了までしばらくお待ちください。",
    AlreadyProcessing: "テキスト化処理中です。しばらく待ってから再度お試しください。",
    RecordNotFound: "対象の録音データが見つかりません。",
    Keyword: "キーワード",
    Creating: "を作成する(EnterまたはTabで決定)",

    // Validation
    Validation_TextSearch: `ワードで検索`,
    Validation_string_input: `文字を入力してください。`,
    Validation_Number_input: `数字を入力してください。`,
    Validation_Select_input: `項目を選んでください。`,
    Validation_File_input: `ファイルを選んでください。`,
    SignIn_UserNotFoundException:"ユーザーが存在しません。システム管理者までお問合せください。",
    PasswordResetRequiredException:"パースワードがリセットされました。システム管理者までお問合せください。",
    Validation_Telno: `電話番号を入力してください。`,
    Validation_ExternalTelno: `外線番号は数字のみで3〜128桁で入力してください（ハイフン不可）。`,
    Validation_Record_System: `ユーザーIDを入力してください。`,
    Validation_DateTime: `検索終了日時を検索開始日時より大きく設定してください。`,

    // 通話分類設定
    Category_Image_Placeholder: "通話分類タグ名を入力してください。",
    Category_Content_Explanation: "通話を分類する判断基準を記載して下さい。判断基準に基づいてAIが分類を行います。",

    // 固有名詞
    ProperNoun_TokenCnt_Explanation: "固有名詞は文字ではなく、トークンとして登録されるため、入力した文字数より、長くカウントされる場合もあります。",
    ProperNoun_TokenCnt_Error: "登録トークン数が制限を超えました。",

    // 要約詳細
    PhoneBook_Unify_Confirm_Message: `"{0}"は既に"{1}"の要約詳細に登録されています。現在の要約詳細に番号を統合しますか？`,
    PhoneBook_External_Number_Duplicated:[
        "※ 同じ番号は一つしか登録できません。",
        "※「統合」を選択しますと、既存の要約詳細は削除され、新しい要約詳細に統合されます。",
    ],

    // PhoneBook - 音声再生
    PhoneBook_PlaybackIdentifierMissing: "録音データの識別情報が不足しています。",
    PhoneBook_PlaybackRecordNotFound: "この通話には録音データが存在しません。",
    PhoneBook_PlaybackPrepareError: "音声再生の準備中にエラーが発生しました。",

    // 外部通知設定
    Notification_Setting_Alarm_Content_Notice: "※アラーム設定がされている通話分類の内容が通知されます。",
    Notification_Setting_Email_Auth_Notice: "※通知の為にはメールアドレスの認証を行ってください。",
    Notification_Setting_Multiple_Email_Notice: "※複数のメールアドレスを指定する場合は、セミコロン (;)で区切ってください。",
    
    // 外部通知設定保存関連
    NotificationSettingSaved: "外部通知設定を保存しました。",
    NotificationSettingSaveFailed: "外部通知設定の保存に失敗しました。",
    
    // メール認証関連
    EmailVerificationSent: "認証メールを送信しました。メールを確認してください。",
    EmailVerificationFailed: "メール認証の処理に失敗しました。",
    
    // メール削除関連
    EmailDeleteSuccess: "メールアドレスを削除しました。",
    EmailDeleteFailed: "メールアドレスの削除に失敗しました。",
    
    // メール重複エラー
    EmailAddressAlreadyRegistered: "このメールアドレスはすでに登録されています",
    
    // メール削除確認
    EmailDeleteConfirm: "このメールアドレスを削除しますか？",
    
    // メールアドレス入力重複エラー
    EmailInputDuplicateError: "入力内に重複するメールアドレスがあります：\n{0}",
    EmailAlreadyRegisteredError: "以下のメールアドレスは既に登録済みです：\n{0}",
    EmailFormatError: "有効なメールアドレス形式で入力してください。",
    EmailAddedSuccess: "{0}件のメールアドレスを追加しました。",
    EmailDuplicateError: "重複するメールアドレスがあります：{0}",
    
    // VoC分析レポート作成開始ダイアログ
    VocAnalysisKickoff: "VoC分析レポートの作成を開始します。\n※ レポート作成の進捗は「VoC分析作成履歴」画面で確認できます。",

    // プレースホルダー
    Placeholder_InputMemo: "メモを入力してください。",
    // 【#549】更新権限が無い利用者向け。空欄だけを見せると「メモが無い」のか
    // 「編集できない」のかが区別できないため、閲覧専用であることを示す
    Placeholder_MemoReadOnly: "メモの編集権限がありません。",

    // PhoneBook統合処理関連
    UnifyProcessError: "結合処理中にエラーが発生しました。再度お試しください。",
    UnifyCompleteInsert: "結合が完了しました。\n既存要約詳細 \"%s\"を削除し\n新規要約詳細 \"%s\"にすべての番号を統合しました。",
    UnifyCompleteUpdate: "結合が完了しました。\n既存要約詳細 \"%s\"を削除し\n要約詳細 \"%s\"にすべての番号を統合しました。",
    
    // PhoneBook統合メッセージ（複数会社）
    UnifyCompleteMultipleInsert: "結合が完了しました。\n既存要約詳細 {0}を削除し\n新規要約詳細 \"{1}\"にすべての番号を結合しました。",
    UnifyCompleteMultipleUpdate: "結合が完了しました。\n既存要約詳細 {0}を削除し\n更新要約詳細 \"{1}\"にすべての番号を結合しました。",
    
    // PhoneBook統合メッセージ（単一会社）
    UnifyCompleteSingleInsert: "結合が完了しました。\n既存要約詳細 \"{0}\"を削除し\n新規要約詳細 \"{1}\"にすべての番号を結合しました。",
    UnifyCompleteSingleUpdate: "結合が完了しました。\n既存要約詳細 \"{0}\"を削除し\n更新要約詳細 \"{1}\"にすべての番号を結合しました。",
    
    // PhoneBook統合メッセージ（フォールバック）
    UnifyFallbackInsert: "新規要約詳細 \"{0}\"を登録しました。",
    UnifyFallbackUpdate: "要約詳細 \"{0}\"を更新しました。",

    // VoCカテゴリメッセージ
    VocCategoryInsertSuccess: 'VoCカテゴリを登録しました',
    VocCategoryUpdateSuccess: 'VoCカテゴリを更新しました',
    VocCategoryUpdateError: 'VoCカテゴリの更新に失敗しました',
    VocCategoryAlreadyDeleted: '選択されたVoCカテゴリーは既に削除されています。一覧を最新化します。',
    VocCategoryDeleteSuccess: 'VoCカテゴリを削除しました',
    VocCategoryDeleteConfirm: '選択したVoCカテゴリを削除してもよろしいですか？',
    Placeholder_InputCategoryName: 'カテゴリ名を入力してください',
    Placeholder_InputPromptText: '分析指示内容を入力してください',
    VocCategoryPromptHint: 'AIに分析させたい内容を具体的に記入してください。例：「会話内容から顧客の商品購入動機を書き出してください。」',
    VocCategorySelectionHint: 'VoC分析で選択できるカテゴリは最大10個です。\n各カテゴリに対して深い分析を行うため、\n重要な分析観点に絞ることで、最適な結果が得られます。',
    NoVocCategoriesAvailable: 'VoCカテゴリが登録されていません',

    // CSVダウンロードエラーメッセージ
    Record_CsvDownloadLimit: 'CSVダウンロードは10,000件までです。検索条件を絞り込んでください。',
    Record_CsvDownloadError: 'CSVダウンロードに失敗しました。',

    // 通話分類タグ編集
    CategoryMinError: "通話分類を1つ以上選択してください。",
    CategoryMaxError: "通話分類は5つまで選択できます。",
    CategoryDuplicateError: "既に同じ通話分類が登録されています。",

    // 電話帳CSVインポート中断エラー
    PhoneBookImportAbortInvalidFormat: "アップロードデータに不正な形式が見つかったため、インポートを中止しました。",
    PhoneBookImportAbortDuplicate: "アップロードデータに重複が見つかったため、インポートを中止しました。",

    // 電話帳CSVインポート
    CsvFileTooLarge: "ファイルサイズが3MBを超えています。",
    CsvInvalidFileFormat: "CSVファイル形式が正しくありません。",
    CsvInvalidStructure: "CSVファイルの構造が正しくありません。ヘッダー行とデータ行を確認してください。",
    CsvMissingRequiredColumn: "必須カラム（名前、電話番号）が見つかりません。テンプレートを確認してください。",
    CsvNoDataSelected: "インポートするデータがありません。",
    CsvImportLimitExceeded: "一度にインポートできるのは{0}件までです（現在：{1}件）。CSVを分割してインポートしてください。",
    PhoneBookImportError: "インポート処理中にエラーが発生しました。",
    IMPORT_TIMEOUT: "処理がタイムアウトしました。処理が続いている可能性があるため、しばらく待ってから一覧で反映状況を確認し、未反映であれば件数を減らして再度取り込んでください。",
    IMPORT_LIMIT_EXCEEDED: "インポート件数が上限を超えています。CSVを分割してインポートしてください。",
    IMPORT_INVALID_SETTING: "インポート設定の値が不正です。画面を再読み込みしてやり直してください。",

    // メール送信設定
    TestMailSuccess: "テストメールを送信しました。",
    TestMailFailed: "テストメール送信に失敗しました。",

    // パートナー管理
    InvalidS3BucketName: "S3バケット名は英小文字・数字・ハイフン・ドットのみ使用できます。",
    DuplicateIdentifier: "同じ識別子のパートナーが既に存在します。",
    PartnerNotFound: "パートナーが見つかりません。",
    InvalidOptionsFormat: "オプションの形式が正しくありません。JSON形式で入力してください。",
    Partner_HasUsersError: "登録されているユーザーがいるため、削除できません。",
    Partner_HasDevicesError: "登録されているデバイスがあるため、削除できません。",
    Partner_HasPermissionsError: "登録されている権限があるため、削除できません。",
    Partner_HasRecordedVoicesError: "録音音声データが存在するため、削除できません。",
    Partner_ModalSelectError: "パートナーを選択してください。",
    Partner_UpdateModalSelectError: "編集は一つのパートナーのみ選択してください。",
    Partner_InvalidJsonError: "オプションの形式が正しくありません。JSON形式で入力してください。",

    // Issue #443: メールOTPによる多要素認証
    SignIn_TooManyAttempts: "ログイン試行回数の上限を超えました。しばらくしてから再度お試しください。",
    Mfa_CodeInvalid: "認証コードが違います。",
    Mfa_CodeInvalidRemaining: "認証コードが違います。あと {0} 回入力できます。",
    Mfa_CodeExpired: "認証コードの有効期限が切れました。もう一度ログインしてください。",
    Mfa_AttemptsExceeded: "認証コードの入力回数が上限を超えました。もう一度ログインしてください。",
    Mfa_SessionExpired: "認証の有効期限が切れました。もう一度ログインしてください。",
    Mfa_ResendCooldown: "再送信の間隔が短いため、送信できませんでした。しばらくしてから再度お試しください。",
    Mfa_ResendLimitExceeded: "認証コードの再送信回数が上限を超えました。もう一度ログインしてください。",
    Mfa_IssueLimitExceeded: "認証コードの送信回数が上限を超えました。しばらくしてから再度お試しください。",
    Account_MailChangeForbidden: "サブユーザーからメールアドレスを変更することはできません。親ユーザーで操作してください。",
    Mfa_MailSendFailed: "認証コードのメール送信に失敗しました。管理者にお問い合わせください。",
    Mfa_MailAddressNotFound: "送信先のメールアドレスが設定されていません。管理者にお問い合わせください。",
    Mfa_VerifyFailed: "認証に失敗しました。",
    Mfa_ResendFailed: "認証コードの再送信に失敗しました。",
    Mfa_CodeResent: "認証コードを再送信しました。",
    Mfa_OffConfirmSuccess: "二要素認証を無効にしました。",
    Mfa_OffError: "二要素認証の無効化に失敗しました。",
    Account_ReauthFailed: "パスワードが違います。",
    Account_ReauthRequired: "パスワードを入力してください。",
    // 【#541】サブID の作成上限を超えたとき。上限はユーザーごとの設定（既定 5 件）
    Account_SubUserLimitExceeded: "サブユーザーの作成上限を超えています。管理者にお問い合わせください。",
    // 【#541】保存中に上限へ達し、一部のサブユーザーだけ作成されなかったとき。
    // 同時に別の操作が走った場合や、保存中に管理者が上限を下げた場合に出る。
    Account_SubUserLimitReachedPartial: "サブユーザーの作成上限（{0}件）に達したため、"
        + "一部のサブユーザーは作成されませんでした。ほかの変更は保存されています。",
}
